import { defaultControles, defaultFiltroControles, defaultFiltroListas, defaultListas } from "./state"

export function setAdmRoles(state, roles) {
    state.roles = roles;
    roles.forEach(rol => {
      state.rolesSeleccionados.push({
          value: rol.id,
          text: rol.descripcion });
      });
}

export function setPermisos(state, permisos) {
    permisos.map(permiso => {
        permiso.editable = false;
    });

    state.permisos = permisos;
}

export function cambiaAdmRolUsuario(state, rol) {
    state.rolusuario = rol;
}

export function setAdmPermisosRol(state, permisos) {
    state.permisosSeleccionados = permisos.data;
}

export function setRolUsuario(state, rol) {
    state.rolusuario = rol.rolusuario;
}

/**
 * Mutación para asignar el nombre del control a las listas
 *
 * @export
 * @param {*} state
 * @param {*} control
 */
export function setNombreControl(state, control) {
    state.nombreControl = control;
}

export function filtroPermiso(state, busca) {
    state.busca = busca;
}

export function setControles(state, controles) {
    state.controles = controles
}

export function setListas(state, listas) {
    state.listas = listas
}
export function setControlSelect(state, listas) {
    state.controlSelect = listas
}

export function setControl(state, control) {
    state.selectedControles = control
    state.accionControl = 'Editar'
}

export function setLista(state, lista) {
    state.selectedListas = lista
    state.accionLista = 'Editar'
}
export function setFiltLista(state, idControl) {
    state.filtroListas.id_control = idControl;
    state.selectedListas.id_control = idControl
}

export function resetSelectedControl(state) {
    state.accionControl = 'Crear'
    Object.assign(state.selectedControles, defaultControles())
}
export function resetSelectedLista(state) {
    state.accionLista = 'Crear'
    Object.assign(state.selectedListas, defaultListas())
}

export function cambiaPermiso(state, id_permiso) {
    var busca = state.permisosSeleccionados.indexOf(id_permiso);
    if (busca == -1) {
        state.permisosSeleccionados.push(id_permiso);
    } else {
        state.permisosSeleccionados.splice(busca, 1);
    }
}

/**
 * Mutación para cambiar la cantidad de registros de controles por página
 *
 * @export
 * @param {*} state
 * @param {*} perPageControles
 */
export function setPerPageControles(state, perPageControles) {
    state.filtroControles.perPage = perPageControles;
}

/**
 * Mutación para cambiar la cantidad de registros de listas por página
 *
 * @export
 * @param {*} state
 * @param {*} perPageListas
 */
 export function setPerPageListas(state, perPageListas) {
    state.filtroListas.perPage = perPageListas;
}

export function cambiaDescripcion(state, descripcion) {
    state.descripcionRol = descripcion;
}
export function setPageControles(state, page) {
    state.filtroControles.page = page
}
export function setPageListas(state, page) {
    state.filtroListas.page = page
}

/**
 * Mutación para mostrar u ocultar el modal de los controles
 *
 * @export
 * @param {*} state
 * @param {boolean} visualizarModalControles
 */
export function setVisualizarModalControles(state, visualizarModalControles) {
    state.visualizarModalControles = visualizarModalControles;
}

/**
 * Mutación para mostrar u ocultar el modal de las listas
 *
 * @export
 * @param {*} state
 * @param {boolean} visualizarModalListas
 */
 export function setVisualizarModalListas(state, visualizarModalListas) {
    state.visualizarModalListas = visualizarModalListas;
}

/**
 * Mutación para limpiar el buscador de controles
 *
 * @export
 * @param {*} state
 */
export function resetFiltroControles(state) {
    Object.assign(state.filtroControles, defaultFiltroControles());
}

/**
 * Mutación para limpiar el buscador de listas
 *
 * @export
 * @param {*} state
 */
export function resetFiltroListas(state) {
    let defaultFListas = defaultFiltroListas();
    defaultFListas.id_control = state.filtroListas.id_control;

    Object.assign(state.filtroListas, defaultFListas);
}

/**
 * Mutación para realizar una búsqueda en controles
 *
 * @export
 * @param {*} state
 * @param {*} buscar
 */
 export function setFiltroControles(state, buscar) {
    state.filtroControles = buscar
}

/**
 * Mutación para realizar una búsqueda en listas
 *
 * @export
 * @param {*} state
 * @param {*} buscar
 */
export function setFiltroListas(state, buscar) {
    Object.assign(state.filtroListas, buscar);
}
